<partner-ingot-base [partner]="partner"></partner-ingot-base>
